// extracted by mini-css-extract-plugin
module.exports = {"root":"History_root__1YMR3","items_wrapper":"History_items_wrapper__1zU9U","empty-history":"History_empty-history__2codv","btn":"History_btn__2dqOL"};